import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoDatePipe, TranslocoDecimalPipe, TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NgxMaskModule } from 'ngx-mask';
import { OrderModule } from 'ngx-order-pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FacilitiesListComponent, LoaderComponent, NotificationsListComponent } from './components';
import { DateLocaledComponent } from './components/date-localed/date-localed.component';
import { InstantMonitorComponent } from './components/instant-monitor/instant-monitor.component';
import { CustomDateFormatPipe } from './pipes/custom-date-format.pipe';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { FilterByPropertyPipe } from './pipes/filter-by-property.pipe';
import { TranslocoRootModule } from './transloco-root.module';

@NgModule({
  declarations: [
    NotificationsListComponent,
    FacilitiesListComponent,
    LoaderComponent,
    EnumToArrayPipe,
    CustomDateFormatPipe,
    FilterByPropertyPipe,
    DateLocaledComponent,
    InstantMonitorComponent
  ],
  exports: [
    NotificationsListComponent,
    FacilitiesListComponent,
    DateLocaledComponent,
    LoaderComponent,
    InstantMonitorComponent,
    CustomDateFormatPipe,
    FilterByPropertyPipe,
    EnumToArrayPipe,
    NgxSpinnerModule,
    TranslocoLocaleModule,
    TranslocoRootModule,
    FormsModule,
    RouterModule,
    OrderModule,
    NzSelectModule,
    CommonModule,
    NzNotificationModule,
    NzDatePickerModule,
    NzButtonModule,
    NzDropDownModule,
    NzCheckboxModule,
    NzResultModule,
    NzEmptyModule,
    NgxMaskModule,
    NzInputModule,
    NzInputNumberModule,
    NzSwitchModule,
    ReactiveFormsModule,
    NzTableModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzSelectModule,
    NzEmptyModule,
    NzModalModule,
    NgxSpinnerModule,
    TranslocoRootModule,
    TranslocoLocaleModule.init(),
    NgxMaskModule.forRoot()
  ],
  providers: [TranslocoDecimalPipe, TranslocoDatePipe]
})
export class SharedModule { }
